import {AccountSettingsSerializedType} from 'sweet-types';

export const settings_fixture: AccountSettingsSerializedType = {
  account_id: 0,
  account_name: 'Your Account',
  account_email: 'account@example.com',
  company_name: 'Your Company',
  company_logo: null,
  industry_classification: 'Online Sales',
  require_ai_data_sharing_at: false,
  is_2fa_required: false,
  owner_email: 'company-owner@example.com',
  can_upload_files: false,
  can_edit_tags: false,
  can_export: false,
  can_see_all_tasks: false,
  can_assign_tasks: false,
  no_managers: 100000,
  no_teammates: 100000,
  no_teams: 100000,
  version_days: 366,
  is_peruser: true,
  STATIC_URL: '/site_media/static/',
  MEDIA_URL: '/site_media/media/',
  MEDIA_URL_READ: '/site_media/media/',
  MEDIA_URL_PROTECTED: '/site_media/media/',
  APP_HTML_VERSION: null,
  EMBEDLY_KEY: 'c50d4c3341094e2a98d053297ffae64a',
  account_teammates: 5,
  account_managers: 2,
  is_brand_tag_enabled: true,
  is_saml: false,
  is_trial_expired: false,
  SECURE_MEDIA_URL_SIGNER: '/demo/api/v1/media-access/',
  switches: {},
  reviews: {
    default_interval: 'P1Y0M0D',
    default_time: 17,
    reminder_time: 'P0Y0M14D',
  },
  vapid_application_server_key: 'vapid_application_server_key',
  is_new_account: false,
  is_paying: true,
  s3Upload: {
    IMAGES: {},
    VIDEOS: {},
    FILES: {},
    UPLOAD: {},
    LOGOAVATAR: {},
    DOCIMPORT: {},
  } as any,
  is_no_active_users: false,
  max_users_limit: 50,
  billable_user_count: 0,
  default_documents_ordering: '-edited_at',
};
